// src/components/Videos.js
export default function Videos() {
  const videoLinks = [
    "https://www.youtube.com/embed/SYjPNiH0kwI?start=401", // Existing video link with timestamp
    // Add more video links here as needed
  ];

  return (
    <div className="p-8 mt-24 text-center">
      <h2 className="text-2xl font-semibold mb-4">Videos</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {videoLinks.map((link, index) => (
          <div key={index} className="w-full aspect-w-16 aspect-h-9">
            <iframe
              src={link}
              title={`Video ${index + 1}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full md:h-[300px] h-[250px] rounded-lg shadow-lg"
            ></iframe>
          </div>
        ))}
      </div>
    </div>
  );
}
